import { AssistantRuntimeProvider } from '@assistant-ui/react';
import { useChatRuntime } from '@assistant-ui/react-ai-sdk';
import { useEffect, useMemo, useRef } from 'react';

const AgentRuntimeProvider = ({ children, runtimeId, transport }) => {
	const ref = useRef(transport);

	// Computed
	const dynamicTransport = useMemo(() => {
		return new Proxy(ref.current, {
			get(_, prop) {
				const value = ref.current[prop];
				return typeof value === 'function' ? value.bind(ref.current) : value;
			},
		});
	}, []);

	const runtime = useChatRuntime({ id: runtimeId, messages: [], transport: dynamicTransport });

	// Hooks
	useEffect(() => {
		ref.current = transport;
	}, [transport]);

	// Render
	return <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>;
};

export { AgentRuntimeProvider };
